var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-container"},[_c('div',{staticClass:"section-header"},[_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("showMore")],2),_c('div',{staticClass:"order-select"},[_c('div',[_vm._t("left")],2),_c('div',[_vm._t("middle")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }